import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinmarkalmidcpune() {



  const cardData =
  {
    keyword: ' Cab Service in Markal MIDC Pune',
    heading: 'Pune Corporate Cars India Private Limited: Cab Service in Markal MIDC Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited provides comprehensive Corporate Mobility Solutions in Pune, designed to support the transportation needs of IT parks, corporate offices, manufacturing units, and business hubs across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures comfortable, safe, and reliable travel for employees, clients, and top management. Whether it is daily office commute, employee transportation, airport transfers, inter-office travel, corporate events, or VIP movement, we deliver seamless and efficient mobility services. With trained chauffeurs, flexible rental programs, dedicated support, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a professional and premium travel experience for businesses operating in Pune.',

    top: 'Top Places to Visit in Markal with Pune Corporate Car',

 "topPlaces": [
  {
    "title": "Mahatma Phule Wada, Markal",
    "description": "Mahatma Phule Wada in Markal is an important cultural landmark that honors the legacy of social reformer Jyotirao Phule. Surrounded by rural landscapes and traditional settlement patterns, the site reflects early social development movements in the region. Visitors can explore the surroundings, local community activities, and rural craftsmanship that represent the lifestyle and society that existed during Phule’s time. The peaceful ambiance and historical connection make it a meaningful stop for those interested in social history and Maharashtra’s reformist movement."
  },
  {
    "title": "Markal Ganesh Temple",
    "description": "Markal Ganesh Temple is a popular spiritual landmark in the village, dedicated to Lord Ganesha. The temple is frequently visited by locals and surrounding villages for daily prayers, religious ceremonies, and community gatherings. Festivals like Ganesh Chaturthi transform the temple into a vibrant hub of devotional music, artistic decorations, and traditional celebrations. The temple’s calm rural setting, combined with its spiritual significance, makes it a serene place to relax, reflect, and experience village devotion."
  },
  {
    "title": "Indrayani River Banks",
    "description": "Markal is located along the scenic stretch of the Indrayani River, providing beautiful natural landscapes ideal for quiet walks, riverside seating, birdwatching, photography, and refreshing mornings. During monsoon, the surroundings become lush and green, creating a tranquil setting perfect for nature lovers. Locals often visit the riverbank for festivals, daily relaxation, or peaceful evening views, offering a simple yet soothing connection with nature and rural charm."
  },
  {
    "title": "Alandi (Nearby Pilgrimage Town)",
    "description": "Just a short drive from Markal, Alandi is one of Maharashtra’s most significant pilgrimage destinations and the spiritual home of Sant Dnyaneshwar. The Dnyaneshwar Samadhi Temple, located on the banks of the Indrayani River, attracts devotees from across India. The town becomes especially vibrant during the annual Pandharpur Wari, when thousands of pilgrims (Warkaris) travel on foot in devotional unity. Walking through Alandi offers a deep cultural experience of spiritual traditions, temple bells, river rituals, devotional singing, and centuries-old Marathi saint literature."
  },
  {
    "title": "Dehu (Birthplace of Sant Tukaram)",
    "description": "Dehu, located close to Markal, is the birthplace of the revered Marathi saint–poet Sant Tukaram. The town is home to the famous Tukaram Maharaj Temple, which sits on the peaceful banks of the Indrayani River. Pilgrims visit throughout the year to attend kirtans, devotional music, spiritual gatherings, and celebrations that honor the legacy of Tukaram’s abhangas (devotional poetry). Dehu forms a holy twin-town circuit with Alandi and offers a rich glimpse into the soul of Maharashtra’s Bhakti tradition."
  },
  {
    "title": "Dighi Hills Viewpoint (Nearby Natural Spot)",
    "description": "The hills near Dighi, not far from Markal, offer a quiet scenic spot for short hikes, nature photography, and open countryside views. During winter and monsoon seasons, the area becomes lush with greenery and misty hillsides. The calm outdoors makes it a great getaway for families or solo travelers looking to experience natural landscapes without traveling far from Pune and surrounding towns."
  },
  {
    "title": "Kadamwak Wasti Biodiversity Surroundings (Nearby)",
    "description": "Kadamwak Wasti, close to Markal, is surrounded by agricultural fields, canal irrigation networks, and bird-friendly green zones. The region provides an authentic countryside environment where visitors can observe traditional farming, seasonal crops, local lifestyle, and occasional migratory birds. It is especially appealing for students, nature lovers, and photographers who want to capture real rural Maharashtra without commercialization."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Accessible Day Trip)",
    "description": "Located within reach for a day trip from Markal, the Rajiv Gandhi Zoological Park in Pune is one of Maharashtra’s major wildlife attractions, featuring a zoo, animal rescue center, botanical surroundings, and the Katraj Lake. The park houses tigers, crocodiles, birds, reptiles, herbivores, and educational exhibits that provide learning experiences for children and visitors. The calm and green environment makes it a refreshing outing that blends nature, awareness, and recreation."
  }
],


"services": [
{
"name": "Employee Transport Management Pune",
"description": "Employee Transport Management Pune offers end-to-end transportation solutions for corporate employees across Pune. The service includes route optimization, GPS tracking, trained drivers, and real-time monitoring to ensure safe, punctual, and efficient commuting for office staff, IT parks, and industrial units. It helps companies streamline employee mobility, reduce commute stress, and enhance overall workforce productivity with structured scheduling and reliable fleet operations."
},
{
"name": "Mobility as a Service Corporate Pune",
"description": "Mobility as a Service Corporate Pune provides integrated corporate mobility solutions, combining multiple transportation modes into a single platform. The service allows companies to manage employee commuting, client travel, and inter-office transport efficiently. Features include digital booking, automated routing, performance tracking, and real-time updates, ensuring seamless mobility, reduced downtime, and a highly optimized corporate travel experience."
},
{
"name": "Staff Shuttle Solutions Pune",
"description": "Staff Shuttle Solutions Pune offers bulk shuttle services for employees working in offices, IT parks, and industrial areas. Using vans and minibuses with dedicated routes and multi-shift support, the service ensures punctual, safe, and comfortable commutes. It reduces traffic congestion, simplifies employee transport management, and provides reliable daily shuttle operations for large workforce groups."
},
{
"name": "Office Commute Automation Pune",
"description": "Office Commute Automation Pune leverages technology to automate employee transportation management. The platform integrates route planning, vehicle allocation, real-time tracking, and shift management to ensure timely pickups and drops. It reduces administrative workload for HR and transport teams, enhances operational efficiency, and ensures employees have a seamless, stress-free commute."
},
{
"name": "Business Fleet Solutions Pune",
"description": "Business Fleet Solutions Pune provides corporate clients with fully managed vehicle fleets for daily employee transport, business trips, and executive travel. The service offers sedans, SUVs, and staff cabs with professional drivers, GPS monitoring, and maintenance support. Companies benefit from optimized fleet utilization, cost efficiency, and high-quality mobility services tailored to organizational needs."
},
{
"name": "Corporate Vehicle Management Pune",
"description": "Corporate Vehicle Management Pune delivers complete management of company vehicles including employee cabs, executive cars, and fleet assets. Services include scheduling, maintenance, driver management, route optimization, and monitoring, ensuring vehicles are always available, safe, and operating efficiently. It helps businesses reduce overheads, increase reliability, and maintain a professional travel experience."
},
{
"name": "Employee Mobility Platforms Pune",
"description": "Employee Mobility Platforms Pune provides digital solutions for managing employee transport, including booking apps, automated scheduling, and real-time tracking. It enables HR and operations teams to monitor trips, optimize routes, reduce commute times, and enhance safety. The platform supports large-scale workforce mobility and helps organizations deliver a seamless commuting experience."
},
{
"name": "Corporate Transport Planning Pune",
"description": "Corporate Transport Planning Pune offers strategic planning and execution of employee transportation across Pune. Services include route design, fleet allocation, shift scheduling, and optimization of travel time and costs. It ensures reliable, safe, and cost-effective mobility for employees, enabling companies to focus on productivity while maintaining smooth commuting operations."
},
{
"name": "Best Mobility Provider Pune",
"description": "Best Mobility Provider Pune delivers top-tier corporate commuting services with a focus on quality, reliability, and professional service. Offering sedans, SUVs, minibuses, and shuttle vans with trained drivers, the service ensures timely pickups, safe travel, and comfortable rides for employees, managers, and visiting clients. It is ideal for companies seeking premium, end-to-end mobility solutions."
},
{
"name": "Workforce Commute Pune",
"description": "Workforce Commute Pune specializes in managing large-scale employee transportation for offices, IT parks, and industrial zones. The service provides structured routes, GPS-enabled vehicles, trained drivers, and real-time monitoring to ensure smooth and safe commutes for employees across multiple shifts. It enhances punctuality, reduces commute-related stress, and supports efficient workforce operations."
},
{
"name": "Smart Office Travel Pune",
"description": "Smart Office Travel Pune offers innovative commuting solutions combining technology, planning, and fleet management. Features include automated booking, shift-based routing, employee tracking, and safety protocols. The service ensures efficient travel for office staff, reduces idle time, optimizes routes, and provides a high-quality commuting experience for employees across Pune."
},
{
"name": "Mobility Optimization Pune",
"description": "Mobility Optimization Pune helps companies enhance efficiency and reduce costs in employee transportation. The service includes intelligent route planning, fleet utilization analysis, real-time tracking, and data-driven insights for better decision-making. It ensures safe, punctual, and comfortable commutes while maximizing operational efficiency and reducing travel-related expenses."
},
{
"name": "Cab Management System Pune",
"description": "Cab Management System Pune provides a digital platform for managing corporate cab services. The system allows companies to schedule pickups, monitor drivers, track vehicles in real-time, and automate reporting. It ensures seamless coordination, reduces administrative effort, improves employee satisfaction, and delivers reliable and professional transportation services."
},
{
"name": "Corporate Fleet Outsourcing Pune",
"description": "Corporate Fleet Outsourcing Pune offers businesses the option to outsource their entire fleet operations to a professional service provider. The service manages vehicles, drivers, maintenance, routing, and employee scheduling, ensuring efficient, reliable, and cost-effective corporate transportation. Companies can focus on core operations while enjoying uninterrupted, high-quality mobility services."
},
{
"name": "Staff Mobility Partner Pune",
"description": "Staff Mobility Partner Pune acts as a dedicated transportation partner for companies, offering end-to-end employee commute solutions. The service includes fleet provision, route planning, GPS tracking, shift management, and safety compliance, ensuring smooth, reliable, and comfortable daily travel for employees, while reducing administrative burden and improving overall operational efficiency."
}
],

"tableData": [
["Employee Transport Management Pune", "Mobility as a Service Corporate Pune"],
["Staff Shuttle Solutions Pune", "Office Commute Automation Pune"],
["Business Fleet Solutions Pune", "Corporate Vehicle Management Pune"],
["Employee Mobility Platforms Pune", "Corporate Transport Planning Pune"],
["Best Mobility Provider Pune", "Workforce Commute Pune"],
["Smart Office Travel Pune", "Mobility Optimization Pune"],
["Cab Management System Pune", "Corporate Fleet Outsourcing Pune"],
["Staff Mobility Partner Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Mobility Solutions in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides comprehensive corporate mobility solutions across Pune, ensuring seamless travel for employees and executives."
  },
  {
    "WhyChooseheading": "Flexible Vehicle Options",
    "WhyChoosedescription": "We offer a wide range of vehicles including sedans, SUVs, tempo travellers, and buses, tailored to meet diverse corporate commuting needs."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Our experienced and courteous drivers ensure safe, punctual, and comfortable transportation for all corporate travelers."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Plans",
    "WhyChoosedescription": "We provide flexible rental packages and travel plans designed to suit the schedules and requirements of businesses across Pune."
  },
  {
    "WhyChooseheading": "Punctual & Reliable Service",
    "WhyChoosedescription": "Our corporate mobility solutions prioritize timely pickups and drops, guaranteeing smooth and hassle-free employee travel."
  },
  {
    "WhyChooseheading": "24/7 Support for Corporate Travel",
    "WhyChoosedescription": "Our team offers round-the-clock assistance for bookings, emergencies, and last-minute changes, ensuring uninterrupted corporate mobility."
  },
  {
    "WhyChooseheading": "Safe & Sanitized Fleet",
    "WhyChoosedescription": "All vehicles are regularly sanitized and maintained with modern safety features to ensure secure and comfortable travel."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Our streamlined booking process and reliable coordination make corporate travel management simple and stress-free."
  }
]

































  }

const faqData = [
  {
    question: 'Do you provide corporate mobility solutions in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers comprehensive corporate mobility solutions including employee transportation, airport transfers, and business travel services in Pune.',
  },
  {
    question: 'What types of services are included in corporate mobility solutions?',
    answer: 'We provide corporate cab services, shuttle services, VIP transfers, outstation travel, and customized mobility plans for companies.',
  },
  {
    question: 'How can companies book corporate mobility services in Pune?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Do you offer customized mobility plans for corporate clients?',
    answer: 'Yes, we design tailored mobility solutions based on company size, employee strength, and travel frequency.',
  },
  {
    question: 'What vehicle options are available for corporate mobility?',
    answer: 'We provide hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on the requirement.',
  },
  {
    question: 'Can companies avail long-term mobility contracts?',
    answer: 'Absolutely. We offer monthly, quarterly, and annual mobility contracts with flexible pricing and billing options.',
  },
  {
    question: 'Do you provide airport transfer services for corporate mobility?',
    answer: 'Yes, we offer timely and reliable airport pickup and drop services for employees and VIP clients.',
  },
  {
    question: 'What safety measures are implemented in corporate mobility services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained chauffeurs adhering to strict safety protocols.',
  },
  {
    question: 'What payment modes are available for corporate mobility services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vivek Deshpande',
    feedback: 'Pune Corporate Cars India Private Limited provides excellent corporate mobility solutions. Timely, professional, and very reliable service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shreya Bhide',
    feedback: 'We use their corporate mobility services for our office commute and airport transfers. Highly dependable and professional.',
    rating: 5,
  },
];





















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Markal MIDC Pune",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-markal.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Markal MIDC, Pune, including employee shuttles, industrial worker transport, staff pickup and drop, business travel cabs, and corporate fleet services. Chauffeur-driven sedans, SUVs, and outstation cabs ensure safe and timely travel for companies and industrial units.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/cab-service-markal-midc-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>Cab Service in Markal MIDC Pune | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited provides reliable corporate cab services in Markal MIDC, Pune, including employee shuttles, industrial worker transport, staff pickup and drop, business travel cabs, and corporate fleet services. Chauffeur-driven sedans, SUVs, and outstation cabs ensure safe and timely travel for companies and industrial units."
  />

  <meta
    name="keywords"
    content="Markal Employee Shuttle, Industrial Worker Cab Markal, Staff Pickup Drop Markal, Corporate Fleet Markal MIDC, Business Travel Cab Markal, Affordable Cab Service Markal, Best Corporate Cab Markal, Monthly Cab Hire Markal, Outstation Cab Markal MIDC, Sedan Cab Markal, SUV Cab Markal, Worker Transport Markal MIDC, Company Cab Markal, Employee Commute Markal, Industrial Shuttle Markal"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinmarkalmidcpune;